if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute('available')) return;

      this.onClickRefreshList = this.onClickRefreshList.bind(this);
this.currentVariant = this.dataset.variantId;
this.fetchAvailability(this.dataset.variantId);
this.bindSizeButtons();
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
this.renderPreview(sectionInnerHTML);
this.bindSizeButtons();
this.updateSizeSelection();
        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';

			if ( this.querySelector('button') ) {
	      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
			}
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('.pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('.pickup-availability-information')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-information').innerHTML;
      this.setAttribute('available', '');

      document.getElementById('Pickup-Availability').innerHTML = sectionInnerHTML.querySelector('.side-availability').innerHTML;

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        document.getElementById('Pickup-Availability').classList.toggle("active");
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');

        evt.preventDefault();
      });
    }

    bindSizeButtons() {
      const sizeButtons = document.querySelectorAll('.pickup-availability-options__size-button');
      sizeButtons.forEach(button => {
        button.addEventListener('click', (evt) => {
          sizeButtons.forEach(btn => btn.classList.remove('active'));
          evt.target.classList.add('active');
          const size = evt.target.dataset.value;
const productData = JSON.parse(document.querySelector('variant-selects script[type="application/json"]').textContent);
const variant = productData.find(v => v.option1 === size);
if (variant) {
  this.currentVariant = variant;
  this.fetchAvailability(variant.id);
  const variantSelects = document.querySelector('variant-selects');
  if (variantSelects) {
    const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset, i) => {
      if (fieldset.querySelector('select')) {
        fieldset.querySelector('select').value = variant.options[i];
      } else if (fieldset.querySelectorAll('input').length) {
        fieldset.querySelector(`input[value="${variant.options[i]}"]`).checked = true;
      }
    });
    variantSelects.dispatchEvent(new Event('change'));
  }
}
        });
      });
    }

    updateSizeSelection() {
      const sizeButtons = document.querySelectorAll('.pickup-availability-options__size-button');
      if (this.currentVariant) {
        sizeButtons.forEach(button => {
          if (button.dataset.value === this.currentVariant.option1) {
            button.classList.add('active');
          }
        });
      }
    }
  });
}
